import React, { memo, useState, useEffect } from "react";
import { useRouter } from "next/router";

import styles from "./NewsContainer.module.scss";

import { PageWrapper, RecomendedQuests, TextComponent, Pagination } from "components";

import dayjs from "dayjs";

import { translit } from "utils";

import { useMutation } from "react-query";

import { baseGetRequest } from "utils/api/api";
import { getNewsUrl } from "utils/api/requestUrls";

const NewsContainer = (props: any) => {
  const { newsFirstData } = props;

  const [data, setData] = useState(newsFirstData);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [data])

  const router = useRouter();

  const { mutate: getNewsData, isLoading: isNewsDataLoading } = useMutation(
    (pageNumber: any) => baseGetRequest(`${getNewsUrl}?page=${pageNumber - 1}`),
    {
      onSuccess: (res) => {
        setData(res)
      },
      onError: (err) => {
        console.warn("error", err);
      },
    }
  );

  const onPaginate = (pageNumber: any) => {
    getNewsData(pageNumber);
  };

  return (
    <>
      <PageWrapper>
        <TextComponent page="news" title="Новости от Old Mouse" isNewsBlock />

        <div className={styles.NewsWrapper}>
          {data?.content?.map((item) => (
            <div className={styles.NewsCard}>
              <div className={styles.Date}>
              { dayjs(item?.lastUpdateDateTime).locale("ru").format("DD")}
              <span className={styles.DateMounth}>{ dayjs(item?.lastUpdateDateTime).locale("ru").format("MMMM")}</span>
              </div>
    

              <div className={styles.NewsCardText}>
                <div>
                  <h1 className={`${styles.NewsCardTextTitle}`}>
                    {item.header}
                  </h1>

                  <div className={styles.NewsCardTextDescription}>
                    {item?.content?.slice(0, 200)}...
                  </div>
                </div>

                <div
                  className={styles.ReadMoreButton}
                  onClick={() =>
                    router.push(`/novosti/${translit(item.header)}`)
                  }
                >
                  Читать все
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.Pagination}>
        <Pagination
          totalPages={data?.totalPages}
          currentPage={data?.number + 1}
          onPaginate={onPaginate}
        />
        </div>
      </PageWrapper>
      <RecomendedQuests {...props} />
    </>
  );
};

export default memo(NewsContainer);
